export default {
  primary: {
    main: "#FF424D",
    dark: "#b30911"
  },
}
